<template>
	<div class="product-badges mb-3">
		<badge-cod :is-cod-enabled="isCodEnabled" class="mr-2"></badge-cod>
		<badge-private :is-private-enabled="isPrivateEnabled" class="mr-2"></badge-private>
		<badge-deleted :is-deleted="isDeletedProduct" class="mr-2"></badge-deleted>
		<badge-lp :is-lp-enabled="isLpEnabled" class="mr-2"></badge-lp>
		<badge-marketing-kit :is-marketing-kit-enabled="isMarketingKitEnabled" class="mr-2"></badge-marketing-kit>
		<badge-dangerous-goods :is-dangerous-goods="isDangerousGoods" class="mr-2"></badge-dangerous-goods>
	</div>
</template>

<script>
import BadgeCod from '@/components/products/BadgeCod.vue';
import BadgePrivate from '@/components/products/BadgePrivate.vue';
import BadgeLp from '@/components/products/BadgeLp.vue';
import BadgeMarketingKit from '@/components/products/BadgeMarketingKit.vue';
import BadgeDeleted from '@/components/products/BadgeDeleted.vue';
import BadgeDangerousGoods from '@/components/products/BadgeDangerousGoods.vue';

export default {
	name: 'Badges',
	components: {
		BadgeCod,
		BadgePrivate,
		BadgeLp,
		BadgeMarketingKit,
		BadgeDeleted,
		BadgeDangerousGoods,
	},
	props: {
		isCodEnabled: {
			type: Boolean,
			default: false,
		},
		isPrivateEnabled: {
			type: Boolean,
			default: false,
		},
		isLpEnabled: {
			type: Boolean,
			default: false,
		},
		isMarketingKitEnabled: {
			type: Boolean,
			default: false,
		},
		isDeletedProduct: {
			type: Boolean,
			default: false,
		},
		isDangerousGoods: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.product-badges {
	height: 16px;
	text-align: left;
}
</style>
